"use client";

import { cn } from "@/lib/utils";

interface LiveIndicatorProps {
  label?: string;
  className?: string;
  size?: "sm" | "md";
}

export function LiveIndicator({ label = "Live", className, size = "sm" }: LiveIndicatorProps) {
  const dotSize = size === "sm" ? "h-1.5 w-1.5" : "h-2 w-2";
  const textSize = size === "sm" ? "text-xs" : "text-sm";

  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <span className="relative flex">
        <span className={cn("animate-ping absolute inline-flex h-full w-full rounded-full bg-primary/60", dotSize)} />
        <span className={cn("relative inline-flex rounded-full bg-primary", dotSize)} />
      </span>
      <span className={cn("font-medium text-muted-foreground uppercase tracking-wider", textSize)}>
        {label}
      </span>
    </span>
  );
}
